import request from '@/util/request';
import qs from 'qs';

//分页
export const getPage = (params, options) =>
  request.get('/api/v4ward/business-manage/page', Object.assign({}, options, { params }));

//详情
export const getDetail = (params, options) =>
  request.get('/api/v4ward/business-manage/detail', Object.assign({}, options, { params }))

//删除
export const remove = (params, options) =>
  request.post('/api/v4ward/business-manage/remove', qs.stringify(params),options);

//新增
export const save = (params, options) =>
  request.post('/api/v4ward/business-manage/save', params,options)

//编辑
export const update = (params, options) =>
  request.post('/api/v4ward/business-manage/update', params,options)
